import React from "react";
import Setting from "../../settings/Setting";
import { AuthContext } from "../../../util/context";
import { useContext } from "react";
import Login from "../../auth/Login";
import Dashboard from "../../dashboard/Dashboard";

export default function SettingPage() {
  let view;
  const { isAuthenticated, user, isUser } = useContext(AuthContext);

  const viewSettings =
    user?.job_role?.toLowerCase() === "seed" ||
    user?.job_role?.toLowerCase() === "hr";

  if (viewSettings) {
    view = <Setting />;
  } else {
    view = <Dashboard />;
  }
  return <>{isAuthenticated && isUser ? view : <Login />}</>;
}
